import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact field text as it appears in the source file (matched case-insensitively, for rows on the Farm below).',
  },
  {
    key: 'businessId',
    label: 'Business',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/businesses/list',
    displayKey: 'businessName',
  },
  {
    key: 'farmFeatureId',
    label: 'Farm',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/spatial-features?category=Farm',
    dependsOnKey: 'businessId',
    displayKey: 'farmName',
  },
  {
    key: 'spatialFeatureId',
    label: 'Field',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/spatial-features?category=Field',
    dependsOnKey: 'farmFeatureId',
    displayKey: 'spatialFeatureName',
  },
];

// Admin view of FieldAlias — same shape as FarmAliasManagement, for the
// Field field instead of Farm, keyed by Farm + raw text: the same field text
// on two farms is two aliases, and the Field list only offers the chosen
// Farm's fields (the API refuses any other). See FieldAlias.cs.
const FieldAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Field Map"
    icon={<LinkIcon />}
    apiPath="/api/field-aliases"
    fields={fields}
    entityLabel="Field Alias"
    softDelete={false}
  />
);

export default FieldAliasManagement;
